import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af9867f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Détermination de l'annuité", -1 /* HOISTED */))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Montant"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Taux (%)"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Terme (années)"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Annuité ($)")
  ])
], -1 /* HOISTED */))
const _hoisted_6 = { class: "mnt" }
const _hoisted_7 = { class: "num" }
const _hoisted_8 = { class: "num" }
const _hoisted_9 = ["onUpdate:modelValue", "readonly", "onChange"]
const _hoisted_10 = { class: "mnt" }
const _hoisted_11 = { class: "mnt total" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "mnt total" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Fardeau fiscal de l'emprunt", -1 /* HOISTED */))
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "table" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Base d'imposition"),
    /*#__PURE__*/_createElementVNode("th", null, "Type de contribuables"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Montant"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Assiette totale imposable"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Unité moyenne imposable"),
    /*#__PURE__*/_createElementVNode("th", { class: "mnt-th" }, "Charge fiscale"),
    /*#__PURE__*/_createElementVNode("th", null, "Précisions")
  ])
], -1 /* HOISTED */))
const _hoisted_22 = ["onUpdate:modelValue", "disabled"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["onUpdate:modelValue", "disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mnt" }
const _hoisted_27 = { class: "num" }
const _hoisted_28 = { class: "num" }
const _hoisted_29 = { class: "mnt" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_32 = { class: "mnt total" }
const _hoisted_33 = ["value"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Total (A)", -1 /* HOISTED */))
const _hoisted_36 = { class: "mnt total" }
const _hoisted_37 = ["value"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_39 = { class: "card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Fardeau fiscal actuel", -1 /* HOISTED */))
const _hoisted_41 = { class: "card-body fardeau-fiscal-actuel-body" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "d-inline-block" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Taxe(s) générale(s) sur la valeur foncière", -1 /* HOISTED */))
const _hoisted_45 = { class: "form-group mnt" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.taxeGenerale.taux" }, "Taux", -1 /* HOISTED */))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " /100$ x ", -1 /* HOISTED */))
const _hoisted_48 = { class: "form-group mnt" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.taxeGenerale.evaluation" }, "Évaluation", -1 /* HOISTED */))
const _hoisted_50 = { class: "d-inline-block" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1 /* HOISTED */))
const _hoisted_52 = { class: "form-group mnt" }
const _hoisted_53 = { class: "text-end mt-3" }
const _hoisted_54 = { class: "d-inline-block" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tarification", -1 /* HOISTED */))
const _hoisted_56 = { class: "form-group mnt" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.tarification.eau" }, "Eau", -1 /* HOISTED */))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_59 = { class: "form-group mnt" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.tarification.egouts" }, "Égouts", -1 /* HOISTED */))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_62 = { class: "form-group mnt" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.tarification.ordures" }, "Ordures", -1 /* HOISTED */))
const _hoisted_64 = { class: "d-inline-block" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1 /* HOISTED */))
const _hoisted_66 = { class: "form-group mnt" }
const _hoisted_67 = { class: "text-end mt-3" }
const _hoisted_68 = { class: "d-inline-block" }
const _hoisted_69 = { class: "form-group autres-taxes" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repartitionFiscale.fardeauFiscalActuel.autresTaxes.precision" }, "Autres taxes, précisez", -1 /* HOISTED */))
const _hoisted_71 = ["readonly"]
const _hoisted_72 = { class: "d-inline-block" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1 /* HOISTED */))
const _hoisted_74 = { class: "form-group mnt" }
const _hoisted_75 = { class: "text-end" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Total (B)", -1 /* HOISTED */))
const _hoisted_77 = { class: "form-group mnt total" }
const _hoisted_78 = { class: "text-end" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Fardeau fiscal total (A + B)", -1 /* HOISTED */))
const _hoisted_80 = { class: "form-group mnt total" }
const _hoisted_81 = { class: "text-end" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Variation (%)", -1 /* HOISTED */))
const _hoisted_83 = { class: "form-group num total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMontant = _resolveComponent("InputMontant")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Répartition fiscale",
    "forced-opened": _ctx.forcedOpened
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglement.repartitionFiscale.annuite, (annuite) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_InputMontant, {
                      parent: annuite,
                      champ: "montant",
                      readonly: _ctx.readonly,
                      "on-input": _ctx.calculerAnnuite(annuite)
                    }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_InputMontant, {
                      parent: annuite,
                      champ: "taux",
                      readonly: _ctx.readonly,
                      "on-input": _ctx.calculerAnnuite(annuite)
                    }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"]),
                    _createTextVNode(" % ")
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((annuite.terme) = $event),
                      min: "1",
                      max: "25",
                      step: "1",
                      readonly: _ctx.readonly,
                      class: "form-control input-print-keep-margin",
                      onChange: ($event: any) => (_ctx.calculerAnnuite(annuite))
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9), [
                      [_vModelText, annuite.terme]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(_component_InputMontant, {
                      parent: annuite,
                      champ: "annuite",
                      readonly: ""
                    }, null, 8 /* PROPS */, ["parent"])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    readonly: "",
                    value: (_ctx.reglement.repartitionFiscale.annuite.reduce((somme, montant) => somme += (montant.montant || 0), 0) || 0).toFixed(2)
                  }, null, 8 /* PROPS */, _hoisted_12)
                ]),
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("th", _hoisted_15, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    readonly: "",
                    value: (_ctx.reglement.repartitionFiscale.annuite.reduce((somme, montant) => somme += (montant.annuite || 0), 0) || 0).toFixed(2)
                  }, null, 8 /* PROPS */, _hoisted_16)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglement.repartitionFiscale.fardeauFiscalEmprunt, (fardeauFiscalEmprunt) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      id: "fardeauFiscalEmprunt.baseImposition",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ajouterLigneFardeauFiscalEmprunt && _ctx.ajouterLigneFardeauFiscalEmprunt(...args))),
                      "onUpdate:modelValue": ($event: any) => ((fardeauFiscalEmprunt.baseImposition) = $event),
                      disabled: _ctx.readonly
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BaseImposition, (baseImposition) => {
                        return (_openBlock(), _createElementBlock("option", { value: baseImposition }, _toDisplayString(baseImposition), 9 /* TEXT, PROPS */, _hoisted_23))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_22), [
                      [_vModelSelect, fardeauFiscalEmprunt.baseImposition]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      id: "fardeauFiscalEmprunt.typeContribuable",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ajouterLigneFardeauFiscalEmprunt && _ctx.ajouterLigneFardeauFiscalEmprunt(...args))),
                      "onUpdate:modelValue": ($event: any) => ((fardeauFiscalEmprunt.typeContribuable) = $event),
                      disabled: _ctx.readonly
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TypeContribuable, (typeContribuable) => {
                        return (_openBlock(), _createElementBlock("option", { value: typeContribuable }, _toDisplayString(typeContribuable), 9 /* TEXT, PROPS */, _hoisted_25))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_24), [
                      [_vModelSelect, fardeauFiscalEmprunt.typeContribuable]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _createVNode(_component_InputMontant, {
                      parent: fardeauFiscalEmprunt,
                      champ: "montant",
                      readonly: _ctx.readonly,
                      "on-input": _ctx.calculerChargeFiscale(fardeauFiscalEmprunt)
                    }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createVNode(_component_InputMontant, {
                      parent: fardeauFiscalEmprunt,
                      champ: "assietteTotaleImposable",
                      readonly: _ctx.readonly,
                      "on-input": _ctx.calculerChargeFiscale(fardeauFiscalEmprunt)
                    }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    _createVNode(_component_InputMontant, {
                      parent: fardeauFiscalEmprunt,
                      champ: "uniteMoyenneImposable",
                      readonly: _ctx.readonly,
                      "on-input": _ctx.calculerChargeFiscale(fardeauFiscalEmprunt)
                    }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    _createVNode(_component_InputMontant, {
                      parent: fardeauFiscalEmprunt,
                      champ: "chargeFiscale",
                      readonly: ""
                    }, null, 8 /* PROPS */, ["parent"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.BaseImpositionUnitePrecision[fardeauFiscalEmprunt.baseImposition]), 1 /* TEXT */)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _hoisted_30,
                _hoisted_31,
                _createElementVNode("th", _hoisted_32, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    readonly: "",
                    value: (_ctx.reglement.repartitionFiscale.fardeauFiscalEmprunt.reduce((somme, montant) => somme += (montant.montant || 0), 0) || 0).toFixed(2)
                  }, null, 8 /* PROPS */, _hoisted_33)
                ]),
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("th", _hoisted_36, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    readonly: "",
                    value: _ctx.reglement.repartitionFiscale.fardeauFiscalEmprunt.reduce((somme, montant) => somme += (montant.chargeFiscale || 0), 0).toFixed(2)
                  }, null, 8 /* PROPS */, _hoisted_37)
                ]),
                _hoisted_38
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.taxeGenerale,
                    id: "repartitionFiscale.fardeauFiscalActuel.taxeGenerale.taux",
                    "on-input": _ctx.calculerFardeauActuelTaxe,
                    champ: "taux",
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ]),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.taxeGenerale,
                    id: "repartitionFiscale.fardeauFiscalActuel.taxeGenerale.evaluation",
                    "on-input": _ctx.calculerFardeauActuelTaxe,
                    champ: "evaluation",
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_InputMontant, {
                    class: "mt-4",
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.taxeGenerale,
                    champ: "total",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.tarification,
                    id: "repartitionFiscale.fardeauFiscalActuel.tarification.eau",
                    "on-input": _ctx.calculerFardeauActuelTarification,
                    champ: "eau",
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ]),
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.tarification,
                    id: "repartitionFiscale.fardeauFiscalActuel.tarification.egouts",
                    "on-input": _ctx.calculerFardeauActuelTarification,
                    champ: "egouts",
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ]),
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.tarification,
                    id: "repartitionFiscale.fardeauFiscalActuel.tarification.ordures",
                    "on-input": _ctx.calculerFardeauActuelTarification,
                    champ: "ordures",
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_InputMontant, {
                    class: "mt-4",
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.tarification,
                    id: "repartitionFiscale.fardeauFiscalActuel.tarification.total",
                    champ: "total",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "repartitionFiscale.fardeauFiscalActuel.autresTaxes.precision",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reglement.repartitionFiscale.fardeauFiscalActuel.autresTaxes.precision) = $event)),
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, _hoisted_71), [
                    [_vModelText, _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.autresTaxes.precision]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_InputMontant, {
                    class: "mt-4",
                    parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel.autresTaxes,
                    champ: "montant",
                    id: "epartitionFiscale.fardeauFiscalActuel.autresTaxes.montant",
                    "on-input": _ctx.calculerFardeauActuelTotal,
                    readonly: _ctx.readonly
                  }, null, 8 /* PROPS */, ["parent", "on-input", "readonly"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_InputMontant, {
                  class: "mt-2",
                  id: "repartitionFiscale.fardeauFiscalActuel.total",
                  parent: _ctx.reglement.repartitionFiscale.fardeauFiscalActuel,
                  champ: "total",
                  readonly: ""
                }, null, 8 /* PROPS */, ["parent"])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_InputMontant, {
                  class: "mt-2",
                  id: "repartitionFiscale.fardeauFiscalTotal",
                  parent: _ctx.reglement.repartitionFiscale,
                  champ: "fardeauFiscalTotal",
                  readonly: ""
                }, null, 8 /* PROPS */, ["parent"])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_InputMontant, {
                  class: "mt-2",
                  id: "repartitionFiscale.variationPourcentage",
                  parent: _ctx.reglement.repartitionFiscale,
                  champ: "variationPourcentage",
                  readonly: ""
                }, null, 8 /* PROPS */, ["parent"]),
                _createTextVNode("% ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}